export default __webpack_public_path__ + "static/media/music.dd9e091b.svg";